import { Button, Form } from "react-bootstrap";
import logo from "../../../images/logo/Icon_company.png";
import { useState } from "react";
import LoadingStuck from "../../reuse/LoadingStuck";
import Api from "../../../api/Api";
import { useParams } from "react-router";


const RestorePasswordForm = () => {
    const [loading,setLoading]=useState(false);
    const [error,setError]=useState(false);
    const [block,setBlock]=useState(true);
    const [errorInfo,setErrorInfo]=useState(null);

    const [typeField, setTypeField]=useState("password");

    const [newPasswordValue,setNewPasswordValue]=useState("");

    const {username}=useParams();
    const {reset_code}=useParams();

    const changePassword = async(data) => {
        try {
            const response = await Api({
                 method:"post",
                url:`/auth/reset_password_apply`,
                data:data
            })
            alert("Пароль изменён.")
            window.location.href="/login"
        } catch (error) {
            setErrorInfo(`Ошибка при изменении пароля \n ${error}`);
            setError(true)
        }
    }

    const checkUpperScale = (pwd) => /[A-ZА-ЯЁ]/.test(pwd);
    const checkLowerScale = (pwd) => /[a-zа-яё]/.test(pwd);
    const checkNumiric = (pwd) => /[0-9]/.test(pwd);
    const checkSpecialSymbols = (pwd) => /[!@#$%^&*(),.?":{}|<>/]/.test(pwd);
    const checkLength = (pwd) => pwd.length > 10;

    const setColor = (ruleCheck) => {
        if(newPasswordValue!==""){
            switch (ruleCheck){
                case true:
                    return {color:"green"};
                    break;
                case false:
                    return {color:"red"};
                    break;
                default:
                    return {color:"black"};
                    break;
            }
        }else{
            return {color:"black"};
        }
    }



    const handleChangePassword = async(e) => {
        e.preventDefault();
        if (checkLength(newPasswordValue) && checkLowerScale(newPasswordValue) && checkNumiric(newPasswordValue)
        && checkSpecialSymbols(newPasswordValue) && checkUpperScale(newPasswordValue)){
            const data = {
                "username":document.getElementById("username").value,
                "reset_code":document.getElementById("reset_code").value,
                "new_password":document.getElementById("new_password").value
            }
            loading(true);
            block(false);
            await changePassword(data);
            loading(false);
            block(true);
        }else{
            alert("Требования к паролю не соблюдены")
        }
    }
    
    return(
        <>
        <div className="block_page_auth">
            <div className="auth_block">
                <div className="auth_card_block">
                    <div className="image_icon_block">
                        <img 
                            src={logo}
                            className="image_icon_logo"
                            alt="Logo" 
                        />
                    </div>
                    <div className="welcome_text">Сброс пароля</div>
                    {loading && <LoadingStuck/>}
                    {block && <Form onSubmit={handleChangePassword}>
                        <Form.Group className="mb-3">
                            <Form.Control 
                            id="username"
                            placeholder="Логин..."
                            value={username}
                            disabled
                            required/>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Control 
                            id="reset_code"
                            type={typeField} 
                            placeholder="reset code ..."
                            value={reset_code}
                            disabled
                            required/>
                        </Form.Group>
                        <Form.Group className="mb-2">
                            <Form.Control 
                            id="new_password"
                            type={typeField}  
                            onChange={(e)=>{setNewPasswordValue(e.target.value)}}
                            placeholder="Введите пароль..."
                            required/>
                        </Form.Group>
                        <Form.Group className="mb-2">
                            <Form.Check type="switch" onChange={(e)=>{e.target.checked ? setTypeField("text") : setTypeField("password")}} label="Показать/скрыть пароли"/>
                        </Form.Group>
                        <div>
                            <div>Требования к паролю:</div>
                            <ul>
                                <li style={setColor(checkLength(newPasswordValue))}>От 10 символов;</li>
                                <li style={setColor(checkLowerScale(newPasswordValue))}>Минимум одна прописная буква(abcdef...z);</li>
                                <li style={setColor(checkUpperScale(newPasswordValue))}>Минимум одна заглавная буква(ABCDEF...Z);</li>
                                <li style={setColor(checkNumiric(newPasswordValue))}>Минимум одна цифра(12345...0);</li>
                                <li style={setColor(checkSpecialSymbols(newPasswordValue))}>Минимум один спецсимвол(!$@%^.../);</li>
                            </ul>
                        </div>
                        {error && <div className="mb-3 warning_text">{errorInfo || "Ошибка"}</div>}
                        <div className="mb-3">
                            <Button 
                            type="submit"
                            variant="primary"
                            className="free-btn">Сбросить пароль</Button>
                        </div>
                    </Form>
                    }
                </div>
            </div>
        </div>
        </>
    )
}

export default RestorePasswordForm;